import Banner from "../components/Banner";
import Products from "./Products";
import "../App.css";



export default function Home() {
    return (
      <>
        <Banner />
        <Products />
      </>
    );
}